<template>
	<LeftSidebar :dark=true :right="true" :open="optionsSidebarOpen" :width="320" :updateSidebar="updateOptionsSidebar">
 		
 		<div slot="sbTitle">
			Settings
    	</div> 
    	
    	<div slot="sbContent" class="pt-4 pr-4">
            
            <v-list class="pl-4 switches">
                
                <v-list-tile>
                    <v-switch
                        label="Building Labels"
                        v-model="showBuildingLabels"
                    ></v-switch>
                </v-list-tile>
                <v-list-tile>
                    <v-switch
                        label="Dark Mode"
                        v-model="darkTheme"
                    ></v-switch>
                </v-list-tile>
                <v-list-tile>
                    <v-switch
                        label="Single Building"
                        v-model="singleBuildingMode"
                    ></v-switch>
                </v-list-tile>
                <v-list-tile  >
                    <v-switch v-if="!singleBuildingMode"
                        label="Line Detail"
                        v-model="showLineDetail"
                    ></v-switch>
                </v-list-tile>
                <v-list-tile  >
                    <v-switch 
                        label="Show All Room Numbers"
                        v-model="showAllRoomNumbers"
                    ></v-switch>
                </v-list-tile>

                <v-list-tile class="mb-5" @click="saveMapCenter">
                    <v-list-tile-action>
                        <v-icon>gps_fixed</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Set Default Map Center</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

            </v-list>  		
    	</div>
	    
	</LeftSidebar>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { LINE_DETAIL_COOKIE } from '@/store/modules/user'
import LeftSidebar from './LeftSidebar'

	  	let OptionsSidebar = {

			data() {
		  		return  {	}
		},

		components: { LeftSidebar },

		computed: {
			...mapState({
				optionsSidebarOpen: state => state.ui.optionsSidebarOpen,
                stateShowBuildingLabels: state => state.ui.showBuildingLabels,
                stateDarkTheme: state => state.ui.darkTheme,
                stateSingleBuildingMode: state => state.ui.singleBuildingMode,
                stateShowBasemap: state => state.ui.showBasemap,
                stateShowLineDetail: state => state.ui.showLineDetail,
                userProfile: state => state.user.userProfile,
                stateMap: state => state.mapFunctions.stateMap,
                selectedBuilding: state => state.space.selectedBuilding,
			}),



			showBuildingLabels: {
                get () {
                  return this.stateShowBuildingLabels
                },
                set (value) {
                    this.setShowBuildingLabels(!this.stateShowBuildingLabels)
                }
            },
            darkTheme: {
                get () {
                  return this.stateDarkTheme
                },
                set (value) {
                	if (value) { this.setShowBuildingLabels(false)}
                    this.setDarkTheme(!this.stateDarkTheme)
                    this.loadRIForExtent()
                }
            },
            singleBuildingMode: {
                get () {
                  return this.stateSingleBuildingMode
                },
                set (value) {
                    this.setSingleBuildingMode(!this.stateSingleBuildingMode)
                }
            },

            showLineDetail: {
                get () {
                  return this.stateShowLineDetail

                },
                set (value) {
                    this.setShowLineDetail(value)
                    let planLayer = this.stateMap.getLayer('planlayer')
                    planLayer.clear()
                    value && this.selectedBuilding && this.addFloorPlanDetail(this.selectedBuilding.bldgAlpha)
                }
            },

            showAllRoomNumbers: {
                get () {
                  return this.$store.state.ui.showAllRoomNumbers

                },
                set (value) {
                    this.setShowAllRoomNumbers(value)
                    this.loadRIForExtent()      // This will ensure the labels update
                }
            },
			
		},
		

		methods: {
			...mapActions(['getMapCenter','getZoom', 'updateUserProfile', 'loadRIForExtent', 'addFloorPlanDetail', ]),
		  	...mapMutations([	'updateOptionsSidebar', 
                                'setShowBuildingLabels',
                                'setDarkTheme', 
                                'setSingleBuildingMode',
                                'setShowLineDetail',
                                'setShowAllRoomNumbers',
                                'setUserProfile',
                                'setSnackText',
                                'setUserProfile',
                                'setMapCenter',

		  					]),
			

			saveMapCenter() {
	            this.getMapCenter().then((centerPoint) => {
                    let payload = { center: [centerPoint.x, centerPoint.y], zoom: this.stateMap.getLevel() }
                    this.setMapCenter(payload)
	                this.setSnackText("New default center is set.")
	            })
	        },	

        },	
						
	}
export default OptionsSidebar
</script>


<style>

</style>





// WEBPACK FOOTER //
// src/components/OptionsSidebar.vue